import { useEffect, useState, useContext } from "react";
import { getDomainConfig } from "../../config/config";
import { ReactComponent as MouseEarsIcon } from '../../images/global/mouse-ears.svg';
import { useCart } from "../../hooks/useCart";
import ReactHtmlParser from 'react-html-parser';
import { ABContext } from "../../contexts/ab-context";
import { useTranslation } from "react-i18next";
import { ReactComponent as SparkleIcon } from '../../images/global/sparkles.svg';
import { ReactComponent as MickeyEarsIcon } from '../../images/global/mickeyears.svg';


const AddedExtras = ({ cartData, setCancellationMessage, setTaxMessage }) => {
  const [hotelCategory, setHotelCategory] = useState('');;
  const [extras, setExtras] = useState([]);
  const [extraLogo, setExtraLogo] = useState(null);

  const { isSuccess: cartIsSuccess } = useCart();

  const currentDate = new Date();
  const endOfferDate = new Date('2023-11-10');

  const { t } = useTranslation('common');
  const abContext = useContext(ABContext);

  // CRO-1381-checkout-redesign
  const [isCro1381, setIsCro1381] = useState(false);

  useEffect(() => {
    if ((config.brand !== 'Sw') && abContext.cro1381 !== undefined) setIsCro1381(abContext.cro1381.variant);
  }, [abContext]);
  // END CRO-1381-checkout-redesign

  const supplierIDs = [
    133, // Disneyland Paris Hotels
    130, // Walt Disney World Hotels & WDW hotel partners
    174, // Universal Hotels
  ]

  const updateCancellationMessage = (cancellationMessage) => {
    // setCancellationMessage is passed as a prop so check that it exists before calling it
    if (setCancellationMessage) {
      setCancellationMessage(ReactHtmlParser(cancellationMessage))
    }
  }

  useEffect(() => {

    if (cartIsSuccess) {
      if (cartData.tickets[0].data?.resort_area) {

        const supplier = +cartData.tickets[0].internal?.supplier_id
        setHotelCategory(cartData.tickets[0].data.category);

        if (supplier === supplierIDs[0]) {
          setExtras((extras) => [ "Extra Magic Time", "Free Parking"]);
        }
        else if (supplier === supplierIDs[1] && cartData.tickets.some(ticket => ticket.tags.includes("hotel-tickets"))) {
          setExtras((extras) => [ "Early Theme Park Entry",
          // "Early Access to the Disney Park Pass System"
        ]);
          updateCancellationMessage(`Cancel or Amend for FREE  <span class="free-cancelations__info"><em>i<em><span class="free-cancelations__details">Book with confidence - you can change your hotel arrangements or cancel your booking with a full refund anytime up to 7 days before your arrival date.  We won’t charge an amendment fee for changes, although these will be subject to availability and current pricing. Any price difference will be payable.</span></span>`);
          setExtraLogo(isCro1381 ? <MickeyEarsIcon/> : <MouseEarsIcon/>);
        }
        if (supplier === supplierIDs[1]) {
          let dollarAmount = 200;
          setExtraLogo(isCro1381 ? <MickeyEarsIcon/> : <MouseEarsIcon/>);

          if (hotelCategory === "Deluxe Villas" || hotelCategory === "Deluxe") {
            dollarAmount = 400;
          }

          if (hotelCategory === "Moderate") {
            dollarAmount = 250;
          }

          if (currentDate <= endOfferDate) {
            updateCancellationMessage(`Amend for FREE  <span class="free-cancelations__info"><em>i<em><span class="free-cancelations__details">Book with confidence - you can change your hotel arrangements up to 7 days before your hotel check-in date. We won’t charge an amendment fee for changes, although these will be subject to availability and current pricing. PLUS cancellation charges will be limited to the loss of deposit if you cancel anytime up to 14 days before your check-in date.</span></span>`);
          }

          if (supplier === supplierIDs[1] && currentDate <= endOfferDate) {
            setExtras((extras) => [
              ...extras
            ]);
            updateCancellationMessage(`Amend for FREE before 9 November 2023  <span class="free-cancelations__info"><em>i<em><span class="free-cancelations__details">Book with confidence - you can change your hotel arrangements any time before 9 November 2023 without losing the added value benefit that formed part of your original booking. We won't charge an amendment fee for changes, although these will be subject to availability and current pricing. Any price difference will be payable. PLUS cancellation charges will be limited to the loss of deposit if you cancel anytime up to 14 days before your check-in date.</span></span>`);
          }
        }
        if (+cartData.tickets[0].internal?.supplier_id === supplierIDs[2]) {

          if (hotelCategory === "Premier") {
            updateCancellationMessage(`Amend for FREE  <span class="free-cancelations__info"><em>i<em><span class="free-cancelations__details">Book with confidence - you can change your hotel arrangements up to 7 days before your hotel check-in date. We won’t charge an amendment fee for changes, although these will be subject to availability and current pricing. PLUS cancellation charges will be limited to the loss of deposit if you cancel anytime up to 14 days before your check-in date.</span></span>`);
          }
        }

        if (cartData.charges[0]?.type === "hotel_tax" && +cartData.charges[0]?.price > 0) {
          setTaxMessage("Includes taxes and charges");
        }
      }
    }

  }, [cartIsSuccess, isCro1381]);

  const config = getDomainConfig();

  /* LOADING THE BRANDED SCSS */
  const [styles, setStyles] = useState(false);

  useEffect(() => {
    const getStyles = async (theFileName, theFileEnd) => {
      if (config.brand) {
        let moduleStyles = false;
        try {
          moduleStyles = await import(
            "./" + theFileName + config.brand + theFileEnd
          );
          setStyles(moduleStyles);
        } catch (e) {
          console.error(
            `Styles for ${theFileName} could not be loaded, ${e.message}`
          );
        }
      }
    };

    // Specify file name and end of file name here.
    getStyles("SubTotal", ".module.scss");
  }, [config.brand]);


  return (
    <>
      {extras.length > 0 && (
        <>
          {isCro1381 ?
            <div className={styles.cro1381HotelHeading}>
              <SparkleIcon/>
              <h3 className={styles.extrasHeader}>{t("added-happiness")}</h3>
            </div>
          :
            <h3 className={styles.extrasHeader}><strong>ADDED</strong> Extras</h3>
          }
          <ul className={isCro1381 && `${styles.cro1381HotelMeta} ${styles.cro1381AddedExtras}`}>
            {extras.map((extra, index) => {
              return <li className={styles.addedExtra} key={index}>
                {!!extraLogo && extraLogo}
                {extra}
                </li>;
            })}
          </ul>
        </>
      )}
    </>
  );
};

export default AddedExtras;
